/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CursorPaginationDto } from '../models/cursor-pagination-dto';
import { OffsetPaginationDto } from '../models/offset-pagination-dto';
import { playlistControllerCreate } from '../fn/playlist/playlist-controller-create';
import { PlaylistControllerCreate$Params } from '../fn/playlist/playlist-controller-create';
import { playlistControllerDelete } from '../fn/playlist/playlist-controller-delete';
import { PlaylistControllerDelete$Params } from '../fn/playlist/playlist-controller-delete';
import { playlistControllerFindAll } from '../fn/playlist/playlist-controller-find-all';
import { PlaylistControllerFindAll$Params } from '../fn/playlist/playlist-controller-find-all';
import { playlistControllerFindAllByClientId } from '../fn/playlist/playlist-controller-find-all-by-client-id';
import { PlaylistControllerFindAllByClientId$Params } from '../fn/playlist/playlist-controller-find-all-by-client-id';
import { playlistControllerFindByDeviceId } from '../fn/playlist/playlist-controller-find-by-device-id';
import { PlaylistControllerFindByDeviceId$Params } from '../fn/playlist/playlist-controller-find-by-device-id';
import { playlistControllerFindById } from '../fn/playlist/playlist-controller-find-by-id';
import { PlaylistControllerFindById$Params } from '../fn/playlist/playlist-controller-find-by-id';
import { playlistControllerGetCountByClientId } from '../fn/playlist/playlist-controller-get-count-by-client-id';
import { PlaylistControllerGetCountByClientId$Params } from '../fn/playlist/playlist-controller-get-count-by-client-id';
import { playlistControllerSearchCursor } from '../fn/playlist/playlist-controller-search-cursor';
import { PlaylistControllerSearchCursor$Params } from '../fn/playlist/playlist-controller-search-cursor';
import { playlistControllerSearchOffset } from '../fn/playlist/playlist-controller-search-offset';
import { PlaylistControllerSearchOffset$Params } from '../fn/playlist/playlist-controller-search-offset';
import { playlistControllerUpdate } from '../fn/playlist/playlist-controller-update';
import { PlaylistControllerUpdate$Params } from '../fn/playlist/playlist-controller-update';
import { PlayListDto } from '../models/play-list-dto';

@Injectable({ providedIn: 'root' })
export class PlaylistService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `playlistControllerFindAll()` */
  static readonly PlaylistControllerFindAllPath = '/api/playlist';

  /**
   * 플레이 리스트 전체 조회.
   *
   * 플레이 리스트 전체를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `playlistControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  playlistControllerFindAll$Response(params?: PlaylistControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PlayListDto>>> {
    return playlistControllerFindAll(this.http, this.rootUrl, params, context);
  }

  /**
   * 플레이 리스트 전체 조회.
   *
   * 플레이 리스트 전체를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `playlistControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  playlistControllerFindAll(params?: PlaylistControllerFindAll$Params, context?: HttpContext): Observable<Array<PlayListDto>> {
    return this.playlistControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PlayListDto>>): Array<PlayListDto> => r.body)
    );
  }

  /** Path part for operation `playlistControllerCreate()` */
  static readonly PlaylistControllerCreatePath = '/api/playlist';

  /**
   * 플레이 리스트 생성.
   *
   * 플레이 리스트를 생성합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `playlistControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  playlistControllerCreate$Response(params: PlaylistControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<PlayListDto>> {
    return playlistControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * 플레이 리스트 생성.
   *
   * 플레이 리스트를 생성합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `playlistControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  playlistControllerCreate(params: PlaylistControllerCreate$Params, context?: HttpContext): Observable<PlayListDto> {
    return this.playlistControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlayListDto>): PlayListDto => r.body)
    );
  }

  /** Path part for operation `playlistControllerGetCountByClientId()` */
  static readonly PlaylistControllerGetCountByClientIdPath = '/api/playlist/count/{clientWorkspaceId}';

  /**
   * 관리중 플레이리스트 수 조회.
   *
   * 관리중인 플레이리스트 수를 고객사 ID를 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `playlistControllerGetCountByClientId()` instead.
   *
   * This method doesn't expect any request body.
   */
  playlistControllerGetCountByClientId$Response(params: PlaylistControllerGetCountByClientId$Params, context?: HttpContext): Observable<StrictHttpResponse<number>> {
    return playlistControllerGetCountByClientId(this.http, this.rootUrl, params, context);
  }

  /**
   * 관리중 플레이리스트 수 조회.
   *
   * 관리중인 플레이리스트 수를 고객사 ID를 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `playlistControllerGetCountByClientId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  playlistControllerGetCountByClientId(params: PlaylistControllerGetCountByClientId$Params, context?: HttpContext): Observable<number> {
    return this.playlistControllerGetCountByClientId$Response(params, context).pipe(
      map((r: StrictHttpResponse<number>): number => r.body)
    );
  }

  /** Path part for operation `playlistControllerFindAllByClientId()` */
  static readonly PlaylistControllerFindAllByClientIdPath = '/api/playlist/all/{clientWorkspaceId}';

  /**
   * 고객사 ID 기반 플레이 리스트 전체 조회.
   *
   * 고객사 ID로 플레이 리스트 전체를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `playlistControllerFindAllByClientId()` instead.
   *
   * This method doesn't expect any request body.
   */
  playlistControllerFindAllByClientId$Response(params: PlaylistControllerFindAllByClientId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PlayListDto>>> {
    return playlistControllerFindAllByClientId(this.http, this.rootUrl, params, context);
  }

  /**
   * 고객사 ID 기반 플레이 리스트 전체 조회.
   *
   * 고객사 ID로 플레이 리스트 전체를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `playlistControllerFindAllByClientId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  playlistControllerFindAllByClientId(params: PlaylistControllerFindAllByClientId$Params, context?: HttpContext): Observable<Array<PlayListDto>> {
    return this.playlistControllerFindAllByClientId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PlayListDto>>): Array<PlayListDto> => r.body)
    );
  }

  /** Path part for operation `playlistControllerSearchOffset()` */
  static readonly PlaylistControllerSearchOffsetPath = '/api/playlist/search/offset';

  /**
   * 플레이 리스트 오프셋 기반 조회.
   *
   * 플레이 리스트를 오프셋 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `playlistControllerSearchOffset()` instead.
   *
   * This method doesn't expect any request body.
   */
  playlistControllerSearchOffset$Response(params: PlaylistControllerSearchOffset$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto>> {
    return playlistControllerSearchOffset(this.http, this.rootUrl, params, context);
  }

  /**
   * 플레이 리스트 오프셋 기반 조회.
   *
   * 플레이 리스트를 오프셋 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `playlistControllerSearchOffset$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  playlistControllerSearchOffset(params: PlaylistControllerSearchOffset$Params, context?: HttpContext): Observable<OffsetPaginationDto> {
    return this.playlistControllerSearchOffset$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto>): OffsetPaginationDto => r.body)
    );
  }

  /** Path part for operation `playlistControllerSearchCursor()` */
  static readonly PlaylistControllerSearchCursorPath = '/api/playlist/search/cursor';

  /**
   * 플레이 리스트 커서 기반 조회.
   *
   * 플레이 리스트를 커서 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `playlistControllerSearchCursor()` instead.
   *
   * This method doesn't expect any request body.
   */
  playlistControllerSearchCursor$Response(params: PlaylistControllerSearchCursor$Params, context?: HttpContext): Observable<StrictHttpResponse<CursorPaginationDto>> {
    return playlistControllerSearchCursor(this.http, this.rootUrl, params, context);
  }

  /**
   * 플레이 리스트 커서 기반 조회.
   *
   * 플레이 리스트를 커서 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `playlistControllerSearchCursor$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  playlistControllerSearchCursor(params: PlaylistControllerSearchCursor$Params, context?: HttpContext): Observable<CursorPaginationDto> {
    return this.playlistControllerSearchCursor$Response(params, context).pipe(
      map((r: StrictHttpResponse<CursorPaginationDto>): CursorPaginationDto => r.body)
    );
  }

  /** Path part for operation `playlistControllerFindById()` */
  static readonly PlaylistControllerFindByIdPath = '/api/playlist/{id}';

  /**
   * 플레이 리스트 ID 기반 조회.
   *
   * 플레이 리스트를 ID를 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `playlistControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  playlistControllerFindById$Response(params: PlaylistControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<PlayListDto>> {
    return playlistControllerFindById(this.http, this.rootUrl, params, context);
  }

  /**
   * 플레이 리스트 ID 기반 조회.
   *
   * 플레이 리스트를 ID를 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `playlistControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  playlistControllerFindById(params: PlaylistControllerFindById$Params, context?: HttpContext): Observable<PlayListDto> {
    return this.playlistControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlayListDto>): PlayListDto => r.body)
    );
  }

  /** Path part for operation `playlistControllerFindByDeviceId()` */
  static readonly PlaylistControllerFindByDeviceIdPath = '/api/playlist/device/{deviceId}';

  /**
   * 플레이 리스트 디바이스 ID 기반 조회.
   *
   * 플레이 리스트를 디바이스 ID를 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `playlistControllerFindByDeviceId()` instead.
   *
   * This method doesn't expect any request body.
   */
  playlistControllerFindByDeviceId$Response(params: PlaylistControllerFindByDeviceId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PlayListDto>>> {
    return playlistControllerFindByDeviceId(this.http, this.rootUrl, params, context);
  }

  /**
   * 플레이 리스트 디바이스 ID 기반 조회.
   *
   * 플레이 리스트를 디바이스 ID를 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `playlistControllerFindByDeviceId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  playlistControllerFindByDeviceId(params: PlaylistControllerFindByDeviceId$Params, context?: HttpContext): Observable<Array<PlayListDto>> {
    return this.playlistControllerFindByDeviceId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PlayListDto>>): Array<PlayListDto> => r.body)
    );
  }

  /** Path part for operation `playlistControllerDelete()` */
  static readonly PlaylistControllerDeletePath = '/api/playlist/{clientWorkspaceId}/{playListId}';

  /**
   * 플레이 리스트 삭제.
   *
   * 플레이 리스트를 삭제합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `playlistControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  playlistControllerDelete$Response(params: PlaylistControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<PlayListDto>> {
    return playlistControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * 플레이 리스트 삭제.
   *
   * 플레이 리스트를 삭제합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `playlistControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  playlistControllerDelete(params: PlaylistControllerDelete$Params, context?: HttpContext): Observable<PlayListDto> {
    return this.playlistControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlayListDto>): PlayListDto => r.body)
    );
  }

  /** Path part for operation `playlistControllerUpdate()` */
  static readonly PlaylistControllerUpdatePath = '/api/playlist/{clientWorkspaceId}/{playListId}';

  /**
   * 플레이 리스트 수정.
   *
   * 플레이 리스트를 수정합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `playlistControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  playlistControllerUpdate$Response(params: PlaylistControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<PlayListDto>> {
    return playlistControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * 플레이 리스트 수정.
   *
   * 플레이 리스트를 수정합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `playlistControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  playlistControllerUpdate(params: PlaylistControllerUpdate$Params, context?: HttpContext): Observable<PlayListDto> {
    return this.playlistControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlayListDto>): PlayListDto => r.body)
    );
  }

}
